module.exports = __webpack_public_path__ + "static/media/defaultProfile-primary.928e2ce6.svg";